module.exports = __webpack_public_path__ + "img/icon-use-secureship-blue.74208c94.svg";